import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
import { PlanLovComponent } from '../../common/plan-lov/plan-lov.component';
import { ClientGroupLovDialog } from '../../common/client-group-lov-dialog/client-group-lov-dialog.component';
import { IssSrcComponent } from '../../common/iss-src/iss-src.component';
@Component({
  selector: 'client-group-rates-for-fixed-plan-based-io-maintenance',
  templateUrl: './client-group-rates-for-fixed-plan-based-io-maintenance.component.html',
  styleUrls: ['./client-group-rates-for-fixed-plan-based-io-maintenance.component.css']
})
export class ClientGroupRatesForFixedPlanBasedIOMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = false;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM135';
  sublineDisabled: boolean = true;
  planDisabled:boolean = true;
  moduleName: string = '';

  selectedClientGrp: any = {
    CLIENT_CD: '',
    CLIENT_DESC: '',
    CLIENT_FIELD: ''
  };
  selectedIss: any = {
    ISS_CD: '',
    ISS_NAME: '',
    ISS_FIELD: ''
  };
  selectedLine: any = {
    LINE_CD: '',
    LINE_NAME: '',
    LINE_FIELD: ''
  };

  selectedSubline: any = {
    SUBLINE_CD: '',
    SUBLINE_NAME: '',
    SUBLINE_FIELD: ''
  };

  selectedPlan: any = {
    PLAN_CD: '',
    PLAN_NAME: '',
    PLAN_FIELD: ''
  };

  tempAddedData: any = [];
  tempUpdateData: any = [];

  paramForm = this.formBuilder.group({
    issueCd: [null],
    issueName: [null],
    issueField: [null],
    lineCd: [null],
    lineName: [null],
    lineField: [null],
    sublineCd: [null],
    sublineName: [null],
    sublineField: [null],
    planCd:[null],
    planName:[null],
    planField:[null],
    clientGrpCd: [null],
    clientGrpDesc: [null],
    clientGrpField: [null],
  });
  clientGrpRatesforFixedPlanBasedIOForm = this.formBuilder.group({
    planAmt: [null, [Validators.required, Validators.maxLength(17)]],
    activeTag: ['A', [Validators.required]],
    commissionRate: [null, [Validators.required, Validators.maxLength(13)]],
    noOfDays: [null],
    effDateFrom: [new Date(), [Validators.required]],
    effDateTo: [null],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {  
    this.moduleName = this.jsonDataService.data.moduleList.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  clientGrpRatesforFixedPlanBasedIOTblConfig: any = {
    cols: [
      {
        key: "PLAN_AMT",
        header: "Plan Amount",
        dataType: "currency"
      },
      {
        key: "COMM_RT",
        header: "Comission Rate",
        dataType: "rateDecimal"
      },
      {
        key: "EFF_DATE_FROM",
        header: "Effective Date",
        dataType: "date"
      },
      { 
        key: "EFF_DATE_TO",
        header: "Expiry Date",
        dataType: "date"
      },
      {
        key: "NO_OF_DAYS",
        header: "No. of Days",
        dataType: "number"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '10%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
  }

  initOnGet(): void {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAgencyStdRates();
          });
      this.getAgencyStdRates();
    }
    catch(e) {
    }
  }

  async getAgencyStdRates(){
    try{
      let issueCd = this.paramForm.get('issueCd')?.value;
      let lineCd = this.paramForm.get('lineCd')?.value;
      let sublineCd = this.paramForm.get('sublineCd')?.value;
      let planCd = this.paramForm.get('planCd')?.value;
      let clientGrpCd = this.paramForm.get('clientGrpCd')?.value;

      if (lineCd && issueCd && sublineCd && planCd && clientGrpCd ) {
        const params = {
          queryParams:{
            clientGrpCd: clientGrpCd,
            issueCd: issueCd,
            sublineCd: sublineCd,
            lineCd: lineCd,
            planCd: planCd,
          },
          moduleId: this.moduleId,
          userId: this.userDetailService.userId,
          type: "MODULE"
        }
        this.clientGrpRatesforFixedPlanBasedIOTblConfig.loading = true;
        this.apiCallService.getClientGroupRatesForFixedPlanBasedIO(params).subscribe({
          next: (data: any) => {
            this.securityService.checkRequestKeyResponse(data, ()=>{
              this.securityService.hasValidCsrfToken(data, ()=>{
                data = JSON.parse(this.jsonDataService.decrypt(data.response));
                let rawData:any = [];
                let finalData:any = [];
                if(!Array.isArray(data)){
                  rawData.push(data);
                }
                else{
                  rawData = data;
                }
                // finalData = this.populateTempData(finalData, rawData);
                if(rawData.length>1){
                  rawData.sort(function(a:any, b:any){
                    let aPremRt = Number(a.PLAN_AMT);
                    let bPremRt = Number(b.PLAN_AMT);
                    return aPremRt - bPremRt;
                  });
                }
                this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData = rawData;
                this.clientGrpRatesforFixedPlanBasedIOTblConfig.loading = false;
                this.tempAddedData = [];
                this.tempUpdateData = [];
                this.saveDisabled = this.saveChecker();
              });
            });
          },
          error: (e: any) => {
            this.clientGrpRatesforFixedPlanBasedIOTblConfig.loading = false;
          }
        });
      } else{
        this.clientGrpRatesforFixedPlanBasedIOTblConfig.loading = true;
        this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData = [];
        this.clientGrpRatesforFixedPlanBasedIOTblConfig.loading = false;
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }catch(e){
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }
  updateFormTable() {
    try {
      let fieldPlanAmt = this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value;
      let fieldEffDateFrom = new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value);
      let fieldEffDateTo = this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value?this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let fieldNoOfDays = this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value?+this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value:null;
      let tempInsertChecker = this.tempAddedData.find((line: { PLAN_AMT: any, EFF_DATE_FROM:any }) => 
        +line.PLAN_AMT == +fieldPlanAmt&&getDateNum(new Date(line.EFF_DATE_FROM))==getDateNum(fieldEffDateFrom)
      );
      let tempUpdateChecker = this.tempUpdateData.find((line: { PLAN_AMT: any, EFF_DATE_FROM:any }) => 
        +line.PLAN_AMT == +fieldPlanAmt&&getDateNum(new Date(line.EFF_DATE_FROM))==getDateNum(fieldEffDateFrom)
      );
      
      this.tableDataUpdate();
      // Adds Updated Data that exists in the database to an object array for updated datas
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());
        tempInsertChecker.ISS_CD= this.paramForm.get('issueCd')?.value;
        tempInsertChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempInsertChecker.SUBLINE_CD= this.paramForm.get('sublineCd')?.value;
        tempInsertChecker.PLAN_CD= this.paramForm.get('planCd')?.value;
        tempInsertChecker.CLIENT_CD= this.paramForm.get('clientGrpCd')?.value;
        tempInsertChecker.PLAN_AMT = +this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value;
        tempInsertChecker.ACTIVE_TAG = this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value;
        tempInsertChecker.COMM_RT = +this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value;
        tempInsertChecker.NO_OF_DAYS = fieldNoOfDays;
        tempInsertChecker.EFF_DATE_FROM = this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value), 'yyyy-MM-dd');
        tempInsertChecker.EFF_DATE_TO = fieldEffDateTo;
        tempInsertChecker.REMARKS = this.clientGrpRatesforFixedPlanBasedIOForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.clientGrpRatesforFixedPlanBasedIOForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.ISS_CD= this.paramForm.get('issueCd')?.value;
        tempUpdateChecker.SUBLINE_CD= this.paramForm.get('sublineCd')?.value;
        tempUpdateChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempUpdateChecker.PLAN_CD= this.paramForm.get('planCd')?.value;
        tempUpdateChecker.CLIENT_CD= this.paramForm.get('clientGrpCd')?.value;
        tempUpdateChecker.PLAN_AMT  = +this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value;
        tempUpdateChecker.COMM_RT = +this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value;
        tempUpdateChecker.NO_OF_DAYS = fieldNoOfDays;
        tempUpdateChecker.EFF_DATE_FROM = this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value), 'yyyy-MM-dd');
        tempUpdateChecker.EFF_DATE_TO = fieldEffDateTo;
        tempUpdateChecker.REMARKS = this.clientGrpRatesforFixedPlanBasedIOForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.clientGrpRatesforFixedPlanBasedIOForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.clientGrpRatesforFixedPlanBasedIOForm.patchValue({
        activeTag: this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let fieldEffDateTo = this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value?new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value): null;
      let fieldNoOfDays = this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value?+this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value:null;
      let updateIndex = this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData.indexOf(this.rowClickedData);
      
      this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData[updateIndex] = {
        ISS_CD: this.paramForm.get('issueCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PLAN_CD: this.paramForm.get('planCd')?.value,
        CLIENT_CD: this.paramForm.get('clientGrpCd')?.value,
        PLAN_AMT: +this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value,
        ACTIVE_TAG: this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value,
        COMM_RT: +this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value,
        NO_OF_DAYS: fieldNoOfDays,
        EFF_DATE_FROM: new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value),
        EFF_DATE_TO: fieldEffDateTo,
        REMARKS: this.clientGrpRatesforFixedPlanBasedIOForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.clientGrpRatesforFixedPlanBasedIOForm.get('userID')?.value,
        MODE: 'U'
      };
      this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData = [...this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData];
    }
    catch(e) {
    }
  }

  formValueToData() {
    try {
      let fieldEffDateTo = this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value?this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        ISS_CD: this.paramForm.get('issueCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PLAN_CD: this.paramForm.get('planCd')?.value,
        CLIENT_CD: this.paramForm.get('clientGrpCd')?.value,
        PLAN_AMT: this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value,
        ACTIVE_TAG: this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value,
        COMM_RT: this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value,
        NO_OF_DAYS: this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value,
        EFF_DATE_FROM: this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value), 'yyyy-MM-dd'),
        ORIG_EFF_DATE_FROM: this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value,
        EFF_DATE_TO: fieldEffDateTo,
        REMARKS: this.clientGrpRatesforFixedPlanBasedIOForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.clientGrpRatesforFixedPlanBasedIOForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData = this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData.filter(
        function(e: any) {
          return +e.PLAN_CD !== +clickData.PLAN_CD||getDateNum(new Date(e.EFF_DATE_FROM))!==getDateNum(new Date(clickData.EFF_DATE_FROM));
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {
          return +e.PLAN_CD !== +clickData.PLAN_CD||getDateNum(new Date(e.EFF_DATE_FROM))!==getDateNum(new Date(clickData.EFF_DATE_FROM));
        }
      );
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details deleted!", "success");
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.clientGrpRatesforFixedPlanBasedIOForm.patchValue({
        activeTag: this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let fieldEffDateTo = this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value?this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let fieldNoOfDays = this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value?+this.clientGrpRatesforFixedPlanBasedIOForm.get('noOfDays')?.value:null;
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        ISS_CD: this.paramForm.get('issueCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PLAN_CD: this.paramForm.get('planCd')?.value,
        CLIENT_CD: this.paramForm.get('clientGrpCd')?.value,
        PLAN_AMT: +this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value.toUpperCase(),
        COMM_RT: +this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value,
        EFF_DATE_FROM: this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value), 'yyyy-MM-dd'),
        EFF_DATE_TO: fieldEffDateTo,
        ACTIVE_TAG: this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value,
        NO_OF_DAYS: fieldNoOfDays,
        REMARKS: this.clientGrpRatesforFixedPlanBasedIOForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.clientGrpRatesforFixedPlanBasedIOForm.get('userID')?.value,
        MODE: 'I'
      }
      this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData.unshift(formToData);
      this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData = [...this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){
    this.apiCallService.saveClientGroupRatesForFixedPlanBasedIO(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.initOnGet();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.initOnGet();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
        this.openDialog('ERROR', 'An error has occured while saving details');
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        for(let item of tempChangeData){
          item.PLAN_AMT = item.PLAN_AMT.toString();
          item.COMM_RT = item.COMM_RT.toString();
        }
        this.saveData(tempChangeData);
      } else {
        this.initOnGet();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let evEffDateFrom = getDateNum(new Date(ev.EFF_DATE_FROM));
        return +e.PLAN_CD==+ev.PLAN_CD&&effDateFrom==evEffDateFrom;
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }
  sublineChecker(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      if(lineCd!==''&&lineCd!==null){
        return false;
      }
      else{ 
        return true;
      }
    }catch(e){
      return true;
    }
  }
  planChecker(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      let sublineCd = this.paramForm.get('sublineCd')?.value;
      if(lineCd==''||lineCd==null){
        return true;
      }
      if(sublineCd==''||sublineCd==null){
        return true;
      }
      return false;
    }catch(e){
      return true;
    }
  }
  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.clientGrpRatesforFixedPlanBasedIOForm.get('lineCode')?.disable();
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      let planAmt: string = '';
      let commisionRate: string= '';
      if(this.rowClickedData.PLAN_AMT!==''&&this.rowClickedData.PLAN_AMT!==null){
        planAmt = parseFloat(this.rowClickedData.PLAN_AMT).toFixed(2);
      }
      if(this.rowClickedData.COMM_RT!==''&&this.rowClickedData.COMM_RT!==null){
        commisionRate = parseFloat(this.rowClickedData.COMM_RT).toFixed(9);
      }
      let fieldEffDateTo = this.rowClickedData.EFF_DATE_TO?new Date(this.rowClickedData.EFF_DATE_TO):null;
      this.clientGrpRatesforFixedPlanBasedIOForm.patchValue({
        planAmt: planAmt,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        commissionRate: commisionRate,
        noOfDays: this.rowClickedData.NO_OF_DAYS,
        effDateFrom: new Date(this.rowClickedData.EFF_DATE_FROM),
        effDateTo: fieldEffDateTo,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.clientGrpRatesforFixedPlanBasedIOForm.patchValue({
        planAmt: null,
        activeTag: 'A',
        commissionRate: null,
        noOfDays: null,
        effDateFrom: new Date(),
        effDateTo: null,
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }
  openClientGroupDialog() {
    try {
      this._Dialog.open(ClientGroupLovDialog, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'CLIENT_GROUP',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedClientGrp = data.content;
          this.paramForm.get('clientGrpCd')?.setValue(this.selectedClientGrp.CLIENT_CD==null || this.selectedClientGrp.CLIENT_CD=='' ? '' : this.selectedClientGrp.CLIENT_CD);
          this.paramForm.get('clientGrpDesc')?.setValue(this.selectedClientGrp.CLIENT_CD==null || this.selectedClientGrp.CLIENT_CD=='' ? '' : this.selectedClientGrp.CLIENT_DESC);
          this.paramForm.get('clientGrpField')?.setValue(this.selectedClientGrp.CLIENT_CD==null || this.selectedClientGrp.CLIENT_CD=='' ? '' : this.selectedClientGrp.CLIENT_CD + " - " + this.selectedClientGrp.CLIENT_DESC);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openIssDialog() {
    try {
      this._Dialog.open(IssSrcComponent, {
        width: '512px',
        disableClose: true,
        data: {
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedIss = data.content;
          this.paramForm.get('issueCd')?.setValue(this.selectedIss.ISS_CD==null || this.selectedIss.ISS_CD=='' ? '' : this.selectedIss.ISS_CD);
          this.paramForm.get('issueName')?.setValue(this.selectedIss.ISS_CD==null || this.selectedIss.ISS_CD=='' ? '' : this.selectedIss.ISS_NAME);
          this.paramForm.get('issueField')?.setValue(this.selectedIss.ISS_CD==null || this.selectedIss.ISS_CD=='' ? '' : this.selectedIss.ISS_CD + " - " + this.selectedIss.ISS_NAME);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openLineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'LINE',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedLine = data.content;
          this.paramForm.get('lineCd')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD);
          this.paramForm.get('lineName')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_NAME);
          this.paramForm.get('lineField')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD + " - " + this.selectedLine.LINE_NAME);
        }
        this.paramForm.get('sublineCd')?.setValue(null);
        this.paramForm.get('sublineName')?.setValue(null);
        this.paramForm.get('sublineField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();
        this.sublineDisabled = this.sublineChecker();
      });
    } catch(e) {
    }
  }
  openSublineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'SUBLINE',
          lineCd: this.paramForm.get('lineCd')?.value,
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedSubline = data.content;
          this.paramForm.get('sublineCd')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_CD);
          this.paramForm.get('sublineName')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_NAME);
          this.paramForm.get('sublineField')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_CD+ " - " + this.selectedSubline.SUBLINE_NAME);
        }
        this.paramForm.get('planCd')?.setValue(null);
        this.paramForm.get('planName')?.setValue(null);
        this.paramForm.get('planField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();
        this.planDisabled = this.planChecker();
      });
    } catch(e) {
    }
  }
  openPlanDialog() {
    try {
      this._Dialog.open(PlanLovComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'PLAN',
          lineCd: this.paramForm.get('lineCd')?.value,
          sublineCd: this.paramForm.get('sublineCd')?.value,
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedPlan = data.content;
          this.paramForm.get('planCd')?.setValue(this.selectedPlan.PLAN_CD==null || this.selectedPlan.PLAN_CD=='' ? '' : this.selectedPlan.PLAN_CD);
          this.paramForm.get('planName')?.setValue(this.selectedPlan.PLAN_CD==null || this.selectedPlan.PLAN_CD=='' ? '' : this.selectedPlan.PLAN_NAME);
          this.paramForm.get('planField')?.setValue(this.selectedPlan.PLAN_CD==null || this.selectedPlan.PLAN_CD=='' ? '' : this.selectedPlan.PLAN_CD+ " - " + this.selectedPlan.PLAN_NAME);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }

  populateTempData(finalData:any[], rawData:any[]){
    let issueCd = this.paramForm.get('issueCd')?.value;
    let lineCd = this.paramForm.get('lineCd')?.value;
    let sublineCd = this.paramForm.get('sublineCd')?.value;
    let planCd = this.paramForm.get('planCd')?.value;
    let clientGrpCd = this.paramForm.get('clientGrpCd')?.value;

    let filteredAddedData: any=[];
    let filteredUpdatedData: any=[];
    if(this.tempUpdateData!=null&&this.tempUpdateData.length!=0){
      filteredUpdatedData = this.tempUpdateData.filter(function(item:any){
        if(item.ISS_CD==issueCd&&item.SUBLINE_CD==sublineCd&&item.LINE_CD==lineCd&&item.CLIENT_CD==clientGrpCd&&item.PLAN_CD==planCd){
          finalData = rawData.filter(function(rawDataItem:any){
            if(rawDataItem.ISS_CD==issueCd&&rawDataItem.SUBLINE_CD==sublineCd&&rawDataItem.LINE_CD==lineCd&&rawDataItem.CLIENT_CD==clientGrpCd&&rawDataItem.PLAN_CD==planCd&&rawDataItem.EFF_DATE_FROM==item.EFF_DATE_FROM){
              return false;
            }
            else{
              return true;
            }
          })
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredUpdatedData.length!=0&&filteredUpdatedData!=null){
        finalData = finalData.concat(filteredUpdatedData);
      }
      else{
        finalData = rawData;
      }
    }
    else{
      finalData = rawData;
    }
    
    if(this.tempAddedData!=null&&this.tempAddedData.length!=0){
      filteredAddedData = this.tempAddedData.filter(function(item:any){
        if(item.ISS_CD==issueCd&&item.SUBLINE_CD==sublineCd&&item.LINE_CD==lineCd&&item.CLIENT_CD==clientGrpCd&&item.PLAN_CD==planCd){
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredAddedData.length!=0&&filteredAddedData!=null){
        finalData = finalData.concat(filteredAddedData);
      }
    }
    if(finalData.length>1){
      finalData.sort(function(a, b){
        let aPremRt = Number(a.PLAN_AMT);
        let bPremRt = Number(b.PLAN_AMT);
        return aPremRt - bPremRt;
      });
    }
    return finalData;
  }
  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if (this.effDateToCheck()) {
       setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if(this.rateCheck('commissionRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if(this.numberCheck('planAmt')||this.numberCheck('noOfDays')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.paramForm.get('lineCd')?.value==='' || this.paramForm.get('lineCd')?.value===null
        ||this.paramForm.get('issueCd')?.value==='' || this.paramForm.get('issueCd')?.value===null
        ||this.paramForm.get('sublineCd')?.value==='' || this.paramForm.get('sublineCd')?.value===null
        ||this.paramForm.get('clientGrpCd')?.value==='' || this.paramForm.get('clientGrpCd')?.value===null
        ||this.paramForm.get('planCd')?.value==='' || this.paramForm.get('planCd')?.value===null
        || this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value==='' || this.clientGrpRatesforFixedPlanBasedIOForm.get('planAmt')?.value===null 
        || this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value==='' || this.clientGrpRatesforFixedPlanBasedIOForm.get('activeTag')?.value===null 
        || this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value==='' || this.clientGrpRatesforFixedPlanBasedIOForm.get('commissionRate')?.value===null
        || this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value==='' || this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value===null) {
        this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  validateUpdate() {
    try {
      this.validated = false;
      let fieldPlanCd = parseInt(this.paramForm.get('planCd')?.value);
      let pubUserStdRatesEffDateFrom= getDateNum(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value));
      let filteredTblData = this.clientGrpRatesforFixedPlanBasedIOTblConfig.tblData.filter(function(e:any){
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let ePlanCd = parseInt(e.PLAN_CD);
        if(effDateFrom!=pubUserStdRatesEffDateFrom){
          return true
        }
        else{
          return false
        }
      })
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(filteredTblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if (this.effDateToCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if(this.rateCheck('commissionRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else if(this.numberCheck('planAmt')||this.numberCheck('noOfDays')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("client-group-rates-for-fixed-plan-based-io-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }
  duplicateCheck(tblData:any) {
    try {
      let fieldPlanCd = parseInt(this.paramForm.get('planCd')?.value);
      let fieldEffDateToValue = this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value;
      let fieldEffDateFrom= getDateNum(new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value));
      let fieldEffDateTo= getDateNum(new Date(fieldEffDateToValue))
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let effDateTo = getDateNum(new Date(e.EFF_DATE_TO));
        let ePlanCd = parseInt(e.PLAN_CD);
        if(ePlanCd!==fieldPlanCd){
          return false
        }
        if(fieldEffDateToValue==''||fieldEffDateToValue==null){
          if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
            return true
          }
          return fieldEffDateFrom<=effDateTo;
        }
        if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
          return effDateFrom<=fieldEffDateTo;
        }
        if(fieldEffDateFrom>=effDateFrom&&fieldEffDateTo<=effDateTo){
            return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateFrom){
          return true;
        }
        if(fieldEffDateFrom<=effDateTo&&fieldEffDateTo>=effDateTo){
          return true;
        }
        return false;
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Unable to add record. Date of Effectivity is concurrent with another record. Please enter a different range of Date of Effectivity', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  } 
  effDateToCheck(){
    try{
      let pubUserStdRatesEffDateFrom= new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateFrom')?.value).getTime();
      if(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value!==''&&this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value!==null){
        let pubUserStdRatesEffDateTo= new Date(this.clientGrpRatesforFixedPlanBasedIOForm.get('effDateTo')?.value).getTime();
        if(pubUserStdRatesEffDateTo<pubUserStdRatesEffDateFrom){
          this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Unable to add record. Expiry Date must not be earlier than Effective Date', "E");
          return true
        }
        else{
          return false
        }
      }
      else{
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  rateCheck(fieldName:string){
    let rate = parseFloat(this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value);
    let fieldRate = this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value;
    let fieldLabel = '';
    if(fieldName=='commissionRate'){
      fieldLabel = 'Commission Rate'
    }
    if(fieldRate===''||fieldRate===null){
      return false
    }
    if(rate<0){
      this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
      return true;
    }
    if(rate<1000){
      return false
    }
    else{
      this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Invalid value in '+fieldLabel+' field. The value entered exceeded the maximum limit', "E");
      return true
    }
  }
  numberCheck(fieldName:string){
    let fieldFloat = parseFloat(this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value);
    let fieldAmt = this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value;
    let fieldLabel = '';
    if(fieldName=='planAmt'){
      fieldLabel = 'Plan Amount'
    }
    else if(fieldName=='noOfDays'){
      fieldLabel = 'No. of Days'
    }
    if(fieldAmt===''||fieldAmt===null){
      return false
    }
    if(fieldName!='noOfDays'){
      if(fieldFloat<0){
        this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
        return true;
      }
      if(fieldAmt.length>17){
        this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Invalid value in '+fieldLabel+' field. The value entered exceeded the maximum limit', "E");
        return true
      }
    }
    if(fieldFloat<0){
      this.formService.showFormMsg("client-group-rates-for-fixed-plan-based-io-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
      return true;
    }
    else{
      return false
    }
  }
  rateFormat(fieldName:string){
    if(this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value!==''&&this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value!==null){
      let fieldFloat = parseFloat(this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value.replace(/,/g, ''))
      let fieldRate = fieldFloat.toFixed(9);
      if(isNaN(fieldFloat)||fieldRate=='NaN'){
        this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.setValue('');
      }
      else{
        this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.setValue(fieldRate);
      }
    }
  }
  amtFormat(fieldName:string){
    if(this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value!==''&&this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value!==null){
      let fieldFloat = parseFloat(this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.value.replace(/,/g, ''))
      let fieldAmt = fieldFloat.toFixed(2);
      if(isNaN(fieldFloat)||fieldAmt=='NaN'){
        this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.setValue('');
      }
      else{
        this.clientGrpRatesforFixedPlanBasedIOForm.get(fieldName)?.setValue(fieldAmt);
      }
    }
  }
  datePattern(ev: any) {
    try{
      //let inputChar = String.fromCharCode(event.charCode)
      if (ev.target.value.length<4) {
        let firstPattern = /^\d{2}\/$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,2);
        }
      } else if(ev.target.value.length<7){
        let firstPattern = /^\d{2}\/\d{2}\/$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,5);
        }
      } else if(ev.target.value.length>6&&ev.target.value.length<11){
        let firstPattern = /^\d{2}\/\d{2}\/\d+$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
        }
      } else if(ev.target.value.length==10){
        let firstPattern = /^\d{2}\/\d{2}\/\d{4}$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
        }
      } else{
        ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
      }
    }
    catch(e) {
    }
  }
}
function getDateNum(dateInput:Date){
  if(dateInput==null){
    return 0;
  }
  let year = dateInput.getFullYear();
  let month = dateInput.getMonth()+1;
  let day = dateInput.getDate();
  let resultString = year+""+padLeadingZeros(month, 2)+""+padLeadingZeros(day, 2);
  
  let result = parseInt(resultString);
  return result;
}
function padLeadingZeros(num:number, size:number) {
  let sNum = num+"";
  while (sNum.length < size) sNum = "0" + sNum;
  return sNum;
}